<!-- expired cars component -->
<div class="modal fade" id="expiredCars_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg modal-fullscreen-sm-down">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> تمدید اعتبار خودروها </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body p-0 m-0">

                <ng-container *ngIf="isOpen">

                    <app-vehicle-renewal [isCalled]="true"></app-vehicle-renewal>

                </ng-container>

            </div>

            <div class="modal-footer d-flex justify-content-start"></div>

        </div>

    </div>

</div>
